import firebase from '../../../firebase';

export const openHalloweenOfferPopup = () => dispatch => {
  dispatch({ type: 'TOGGLE_HALLOWEEN_MSG', data: true });
};

export const closeHalloweenOfferPopup = () => dispatch => {
  dispatch({ type: 'TOGGLE_HALLOWEEN_MSG', data: false });
};
